export const AGE_SEGMENT_LABELS = ["Age 35+", "Age 21+", "Age 18-64", "Age 18+"];
